<div
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full mb-2 url-field"
  [ngClass]="{ 'url-field--link': value }"
>
  <ts-input
    [label]="fieldDef.label"
    [testId]="'form-field-' + fieldDef.name"
    [maxlength]="1024"
    [formControl]="control"
    (click)="edit()"
    (keyup.enter)="onBlur()"
    (blur)="onBlur()"
  >
    @if (value && !editing) {
      <ts-button
        tsInputSuffix
        type="icon"
        icon="open_in_new"
        iconTooltip="Navigate to URL"
        class="url-field__navigation"
        (buttonClick)="visitUrl()"
      />
    }
  </ts-input>
</div>
